<template>
  <div class="ods-button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'OdsButtonGroup'
}
</script>
